
        // Dialog Management Functions
        document.addEventListener('DOMContentLoaded', function() {
            const signUpDialog = document.getElementById('signUpDialog');
            const loginDialog = document.getElementById('loginDialog');

            if (signUpDialog) {
                signUpDialog.addEventListener('click', function(e) {
                    if (e.target === signUpDialog) {
                        window.closeLoginDialog();
                    }
                });
            }

            if (loginDialog) {
                loginDialog.addEventListener('click', function(e) {
                    if (e.target === loginDialog) {
                        window.closeLoginDialog();
                    }
                });
            }

            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape') {
                    window.closeLoginDialog();
                    window.closeLoginDialog();
                }
            });
        });

        // Form submission handlers
        window.handleSignUp = function(event) {
            event.preventDefault();
            const firstName = document.getElementById('signUpFirstName').value;
            const lastName = document.getElementById('signUpLastName').value;
            const email = document.getElementById('signUpEmail').value;
            const password = document.getElementById('signUpPassword').value;

            if (window.authManager) {
                // Use existing AuthManager validation
                if (window.authManager.validateCredentials(email, password, false)) {
                    window.authManager.currentUser = {
                        email,
                        firstName: firstName.trim(),
                        lastName: lastName.trim(),
                        name: `${firstName.trim()} ${lastName.trim()}`.trim()
                    };
                    localStorage.setItem('versionaryUser', JSON.stringify(window.authManager.currentUser));
                    window.authManager.isAuthenticated = true;
                    // Close dialog before showing main app
                    window.closeLoginDialog();
                    window.authManager.showMainApp();
                } else {
                    alert('Please ensure password is at least 6 characters long.');
                }
            }
        };

        window.handleLogin = function(event) {
            event.preventDefault();
            const email = document.getElementById('loginEmail').value;
            const password = document.getElementById('loginPassword').value;

            if (window.authManager) {
                // Use existing AuthManager validation
                if (window.authManager.validateCredentials(email, password, true)) {
                    // For demo purposes, create a basic user object
                    window.authManager.currentUser = {
                        email,
                        name: email.split('@')[0]
                    };
                    localStorage.setItem('versionaryUser', JSON.stringify(window.authManager.currentUser));
                    window.authManager.isAuthenticated = true;
                    // Close dialog before showing main app
                    window.closeLoginDialog();
                    window.authManager.showMainApp();
                } else {
                    alert('Invalid credentials. Please try again.');
                }
            }
        };

        function setGoogleButtonLoading(buttonId, isLoading) {
            const button = document.getElementById(buttonId);
            if (!button) return;
            
            if (isLoading) {
                button.disabled = true;
                button.style.opacity = '0.7';
                button.style.cursor = 'not-allowed';
                button.innerHTML = `
                    <div class="loading-spinner"></div>
                    <span>Signing in...</span>
                `;
            } else {
                button.disabled = false;
                button.style.opacity = '1';
                button.style.cursor = 'pointer';
                if (buttonId === 'googleSignUpDialog') {
                    button.innerHTML = `
                        <svg class="auth-google-icon" viewBox="0 0 24 24">
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                        </svg>
                        Sign up with Google
                    `;
                } else if (buttonId === 'googleSignInDialog') {
                    button.innerHTML = `
                        <svg class="auth-google-icon" viewBox="0 0 24 24">
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                        </svg>
                        Sign in with Google
                    `;
                }
            }
        }

        window.handleGoogleSignUp = function() {
            if (window.authManager) {
                setGoogleButtonLoading('googleSignUpDialog', true);
                window._isGoogleAuthLoading = true;
                window.authManager.handleGoogleSignIn();
            }
        };

        window.handleGoogleSignInDialog = function() {
            if (window.authManager) {
                setGoogleButtonLoading('googleSignInDialog', true);
                window._isGoogleAuthLoading = true;
                window.authManager.handleGoogleSignIn();
            }
        };

        // Authentication System
        class AuthManager {
            constructor() {
                this.isAuthenticated = false;
                this.currentUser = null;
                this.init();
            }

            init() {
                // Check if user is already logged in
                const savedUser = localStorage.getItem('versionaryUser');
                if (savedUser) {
                    this.currentUser = JSON.parse(savedUser);
                    this.isAuthenticated = true;
                    this.showMainApp(); // Goes to homepage, not console
                } else {
                    this.showAuthScreen();
                }

                // Set up event listeners
                this.setupEventListeners();
                this.updateTime();
                setInterval(() => this.updateTime(), 1000);
            }

            setupEventListeners() {
                const authForm = document.getElementById('authForm');
                const loginTab = document.getElementById('loginTab');
                const registerTab = document.getElementById('registerTab');
                const googleSignIn = document.getElementById('googleSignIn');

                if (authForm) {
                    authForm.addEventListener('submit', (e) => this.handleAuth(e));
                }

                if (loginTab) {
                    loginTab.addEventListener('click', () => this.switchTab('login'));
                }

                if (registerTab) {
                    registerTab.addEventListener('click', () => this.switchTab('register'));
                }

                if (googleSignIn) {
                    googleSignIn.addEventListener('click', () => this.handleGoogleSignIn());
                }

                // Add logout functionality
            }

            switchTab(tabType) {
                const loginTab = document.getElementById('loginTab');
                const registerTab = document.getElementById('registerTab');
                const submitBtn = document.getElementById('submitBtn');

                if (tabType === 'login') {
                    loginTab.classList.add('active');
                    registerTab.classList.remove('active');
                    submitBtn.textContent = 'Login';
                } else {
                    registerTab.classList.add('active');
                    loginTab.classList.remove('active');
                    submitBtn.textContent = 'Register';
                }
            }

            async handleAuth(e) {
                e.preventDefault();
                
                const firstName = document.getElementById('firstName').value;
                const lastName = document.getElementById('lastName').value;
                const email = document.getElementById('email').value;
                const password = document.getElementById('accessCode').value;
                const isLogin = document.getElementById('loginTab').classList.contains('active');

                // Basic authentication (for now)
                if (this.validateCredentials(email, password, isLogin)) {
                    this.currentUser = { 
                        email, 
                        firstName: firstName.trim(), 
                        lastName: lastName.trim(),
                        name: `${firstName.trim()} ${lastName.trim()}`.trim()
                    };
                    localStorage.setItem('versionaryUser', JSON.stringify(this.currentUser));
                    this.isAuthenticated = true;
                    this.showMainApp(); // Goes to homepage, not console
                } else {
                    this.showError('Invalid credentials. Please try again.');
                }
            }

            validateCredentials(email, password, isLogin) {
                // Basic validation for demo
                if (isLogin) {
                    // Allow any email/password for now
                    return email && password;
                } else {
                    // Registration logic
                    return email && password && password.length >= 6;
                }
            }

            handleGoogleSignIn() {
                console.log('new version sign in');
                try {
                    google.accounts.oauth2.initTokenClient({
                        client_id: "953922644429-oms9ho6asfr659mjhf2brg8o4ljr8vi5.apps.googleusercontent.com",
                        scope: 'openid email profile',
                        callback: (response) => {
                            if (response.access_token) {
                                this.processGoogleAuthResponse(response);
                            } else {
                                this.resetGoogleButtonLoading();
                                this.showError('Google sign-in was cancelled or failed. Please try again.');
                            }
                        }
                    }).requestAccessToken();
                } catch (error) {
                    console.error('Google OAuth initialization failed:', error);
                    this.resetGoogleButtonLoading();
                    this.showError('Google sign-in is temporarily unavailable. Please try the manual login.');
                }
            }

            resetGoogleButtonLoading() {
                window._isGoogleAuthLoading = false;
                const signUpButton = document.getElementById('googleSignUpDialog');
                const loginButton = document.getElementById('googleSignInDialog');
                if (signUpButton && signUpButton.disabled) {
                    setGoogleButtonLoading('googleSignUpDialog', false);
                }
                if (loginButton && loginButton.disabled) {
                    setGoogleButtonLoading('googleSignInDialog', false);
                }
            }

            async processGoogleAuthResponse(tokenResponse) {
                try {
                    // Fetch user info from Google
                    const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
                        headers: {
                            'Authorization': `Bearer ${tokenResponse.access_token}`
                        }
                    });

                    if (!userInfoResponse.ok) {
                        throw new Error('Failed to fetch user information');
                    }

                    const userInfo = await userInfoResponse.json();
                    console.log('Google user info received:', userInfo);

                    this.currentUser = {
                        email: userInfo.email,
                        firstName: userInfo.given_name || '',
                        lastName: userInfo.family_name || '',
                        name: userInfo.name || userInfo.email,
                        picture: userInfo.picture || '',
                        googleId: userInfo.id,
                        verified: userInfo.verified_email || false,
                        authMethod: 'google'
                    };

                    localStorage.setItem('versionaryUser', JSON.stringify(this.currentUser));
                    this.isAuthenticated = true;

                    console.log('Google OAuth login successful:', this.currentUser);
                    
                    window._isGoogleAuthLoading = false;
                    this.showMainApp();
                    
                    setTimeout(() => {
                        const signUpButton = document.getElementById('googleSignUpDialog');
                        const loginButton = document.getElementById('googleSignInDialog');
                        if (signUpButton && signUpButton.disabled) {
                            setGoogleButtonLoading('googleSignUpDialog', false);
                        }
                        if (loginButton && loginButton.disabled) {
                            setGoogleButtonLoading('googleSignInDialog', false);
                        }
                    }, 100);

                } catch (error) {
                    console.error('Google auth processing failed:', error);
                    this.resetGoogleButtonLoading();
                    this.showError('Failed to complete Google sign-in. Please try again or use manual login.');
                }
            }

            showAuthScreen() {
                const authScreen = document.getElementById('authScreen');
                const contentWrapper = document.querySelector('.content-wrapper');
                const taskbar = document.querySelector('.taskbar');

                if (authScreen) authScreen.classList.remove('hidden');
                if (contentWrapper) contentWrapper.style.display = 'none';
                if (taskbar) taskbar.style.display = 'flex';
            }

            showMainApp() {
                const signUpDialog = document.getElementById('signUpDialog');
                const loginDialog = document.getElementById('loginDialog');
                if (signUpDialog && signUpDialog.classList.contains('active')) {
                    window.closeLoginDialog();
                }
                if (loginDialog && loginDialog.classList.contains('active')) {
                    window.closeLoginDialog();
                }
                
                const authScreen = document.getElementById('authScreen');
                const contentWrapper = document.querySelector('.content-wrapper');
                const taskbar = document.querySelector('.taskbar');

                if (authScreen) authScreen.classList.add('hidden');
                if (contentWrapper) contentWrapper.style.display = 'block';
                if (taskbar) taskbar.style.display = 'none';

                // Update user greeting if in console
                const userGreeting = document.getElementById('userGreeting');
                if (userGreeting && this.currentUser) {
                    let userName = 'User';
                    if (this.currentUser.firstName) {
                        userName = this.currentUser.firstName;
                    } else if (this.currentUser.name) {
                        userName = this.currentUser.name.split(' ')[0];
                    } else if (this.currentUser.email) {
                        const emailMatch = this.currentUser.email.match(/(\w+)@/);
                        if (emailMatch && emailMatch[1]) {
                            userName = emailMatch[1].charAt(0).toUpperCase() + emailMatch[1].slice(1);
                        }
                    }
                    userGreeting.textContent = `Hi, ${userName}!`;
                    
                    // Update console user greeting in dropdown
                    const consoleUserGreeting = document.getElementById('consoleUserGreeting');
                    if (consoleUserGreeting) {
                        let firstName = 'User';
                        if (this.currentUser.firstName) {
                            firstName = this.currentUser.firstName;
                        } else if (this.currentUser.name) {
                            firstName = this.currentUser.name.split(' ')[0];
                        } else if (this.currentUser.email) {
                            const emailMatch = this.currentUser.email.match(/(\w+)@/);
                            if (emailMatch && emailMatch[1]) {
                                firstName = emailMatch[1].charAt(0).toUpperCase() + emailMatch[1].slice(1);
                            }
                        }
                        consoleUserGreeting.textContent = `Hi, ${firstName}`;
                    }
                    
                    // Update the main headline with user name
                    if (typeof initializePersonalizedGreeting === 'function') {
                        initializePersonalizedGreeting();
                    }
                    
                    // Update all user greetings
                    if (typeof updateAllUserGreetings === 'function') {
                        updateAllUserGreetings();
                    }
                }
            }
logout() {                localStorage.removeItem('versionaryUser');                this.currentUser = null;                this.isAuthenticated = false;                // Close console and go to auth screen                const masterConsole = document.getElementById('masterConsoleOverlay');                if (masterConsole) {                    masterConsole.classList.remove('active');                }                this.showAuthScreen(); // Go to auth screen on logout            }
            }

            showError(message) {
                const errorElement = document.getElementById('errorMessage');
                if (errorElement) {
                    errorElement.textContent = message;
                    errorElement.classList.remove('hidden');
                    setTimeout(() => errorElement.classList.add('hidden'), 5000);
                }
            }

            updateTime() {
                const timeElement = document.getElementById('taskbarTime');
                if (timeElement) {
                    const now = new Date();
                    const timeString = now.toLocaleTimeString('en-US', { 
                        hour: 'numeric', 
                        minute: '2-digit',
                        hour12: true 
                    });
                    timeElement.textContent = timeString;
                }
            }
        }

        // Consolidated initialization function
        async function initializeVersionary() {
            console.log('🚀 Starting Versionary initialization...');

            // Check for valid session - if no session, let auth.js handle login
            const sessionToken = localStorage.getItem('versionary_session_token');
            if (!sessionToken) {
                console.log('⏭️  No session found - skipping initialization (auth.js will handle login)');
                return;
            }
            
            try {
                // Step 1: Initialize authentication first
                console.log('🔐 Initializing authentication...');
                updateLoadingProgress('auth', 'Initializing authentication...');
                const authManager = new AuthManager();
                window.authManager = authManager;
                await initializeUser();
                
                // Step 2: Preload video backgrounds
                console.log('🎬 Preloading video backgrounds...');
                updateLoadingProgress('video', 'Loading video backgrounds...');
                await preloadVideos();
                
                // Step 3: Initialize theme and UI
                console.log('🎨 Setting up theme and UI...');
                updateLoadingProgress('theme', 'Setting up interface theme...');
                initializeTheme();
                updateAllUserGreetings();
                
                // Step 4: Force agency mode
                console.log('🏢 Switching to agency mode...');
                updateLoadingProgress('agency', 'Activating agency mode...');
                switchToAgency();
                
                // Step 5: Initialize time-adaptive system
                console.log('⏰ Setting up time-adaptive system...');
                updateLoadingProgress('adaptive', 'Configuring time-adaptive system...');
                updateTimeAdaptiveGradient();
                updateTimeAdaptiveVideos();
                
                // Step 6: Restore pipeline state if available
                console.log('💾 Checking for saved state...');
                updateLoadingProgress('state', 'Checking for saved progress...');
                const restoredState = loadPipelineState();
                if (restoredState) {
                    updateLoadingProgress('restore', 'Restoring previous session...');
                    await restorePipelineState(restoredState);
                }
                
                // Step 7: Initialize UI components
                console.log('🔧 Initializing UI components...');
                updateLoadingProgress('ui', 'Initializing UI components...');
                startFileTypeRotation();
                initializeSidebarResize();
                initializePersonalizedGreeting();
                setupDragAndDropListeners();
                setupPlatformCards();
                setupOverlayListeners();
                
                // Step 8: Final theme synchronization
                console.log('🔄 Final theme synchronization...');
                syncAllThemeElements();
                
                // Step 9: Show the interface
                console.log('✨ Showing interface...');
                updateLoadingProgress('final', 'Preparing interface...');
                await showInterface();
                
                console.log('✅ Versionary initialization complete!');
                
            } catch (error) {
                console.error('❌ Initialization failed:', error);
                updateLoadingProgress('error', 'Finalizing setup...');
                // Still show the interface even if something fails
                await showInterface();
            }
        }
        
        async function preloadVideos() {
            return new Promise((resolve) => {
                const agencyVideo = document.querySelector('.agency-video-background');
                if (agencyVideo) {
                    agencyVideo.addEventListener('loadeddata', resolve, { once: true });
                    // Fallback timeout
                    setTimeout(resolve, 2000);
                } else {
                    resolve();
                }
            });
        }
        
        async function restorePipelineState(restoredState) {
            console.log('🔄 Restoring pipeline to previous state');
            
            // Restore current step based on active processing work
            let targetStep = 'batch';
            if (pipelineState.export?.status === 'processing') {
                targetStep = 'export';
            } else if (pipelineState.translate?.status === 'processing') {
                targetStep = 'translate';
            } else if (pipelineState.batch?.status === 'preview_ready' && !pipelineState.batch?.approved) {
                targetStep = 'batch';
            }
            
            console.log('🎯 Target step for restoration:', targetStep);
            console.log('🔍 Active processing detected:', {
                batch: pipelineState.batch?.status,
                translate: pipelineState.translate?.status,
                export: pipelineState.export?.status
            });
            
            // Switch to restored step
            setTimeout(() => {
                console.log('🔄 Switching to restored step:', targetStep);
                switchPipelineStep(targetStep);
                
                // Only show restoration messages for actual active work
                if (pipelineState.translate?.status === 'processing') {
                    addSystemMessage('🔄 Resuming background translation job...');
                }
                if (pipelineState.export?.status === 'processing') {
                    addSystemMessage('🔄 Resuming export processing...');
                }
                if (pipelineState.batch?.status === 'preview_ready' && !pipelineState.batch?.approved) {
                    addSystemMessage('👀 Your video preview is ready for approval');
                }
            }, 500);
            
            // Try to recover any active jobs
            await recoverActiveJobs();
        }
        
        function setupPlatformCards() {
            const platformCards = document.querySelectorAll('.platform-card');
            platformCards.forEach(card => {
                card.addEventListener('click', function() {
                    const checkbox = this.querySelector('input[type="checkbox"]');
                    if (checkbox) {
                        checkbox.checked = !checkbox.checked;
                        this.classList.toggle('selected', checkbox.checked);
                    }
                });
            });
        }
        
        function setupOverlayListeners() {
            // Close overlays when clicking outside
            const dragDropOverlay = document.getElementById('dragDropOverlay');
            if (dragDropOverlay) {
                dragDropOverlay.addEventListener('click', function(e) {
                    if (e.target === this) {
                        hideDragOverlay();
                    }
                });
            }
            
            const uploadModal = document.getElementById('uploadModal');
            if (uploadModal) {
                uploadModal.addEventListener('click', function(e) {
                    if (e.target === this) {
                        hideSimpleUpload();
                    }
                });
            }
        }
        
        function updateLoadingProgress(step, message) {
            const loadingText = document.querySelector('.loading-text');
            const loadingSubtext = document.querySelector('.loading-subtext');
            
            if (loadingText) {
                loadingText.textContent = 'Loading Versionary';
            }
            if (loadingSubtext) {
                loadingSubtext.textContent = message || 'AI-Powered Video Processing';
            }
        }

        async function showInterface() {
            const loadingScreen = document.getElementById('loadingScreen');
            const agencyInterface = document.getElementById('agencyInterface');
            
            // Final loading message
            updateLoadingProgress('complete', 'Ready to create amazing content');
            
            // Small delay to show completion
            await new Promise(resolve => setTimeout(resolve, 800));
            
            // Mark agency interface as loaded
            if (agencyInterface) {
                agencyInterface.classList.add('loaded');
            }
            
            // Hide loading screen with smooth transition
            if (loadingScreen) {
                loadingScreen.classList.add('hidden');
                // Remove from DOM after animation
                setTimeout(() => {
                    if (loadingScreen.parentNode) {
                        loadingScreen.remove();
                    }
                }, 800);
            }
        }

        // Initialize everything - single consolidated event
        document.addEventListener('DOMContentLoaded', initializeVersionary);
    